<div class="row col-12 p-0 m-0">
  <div class="col-12 p-0">
    <!-- <app-header></app-header> -->
    <div class="col-height">
      <div class="breadcrumbs-section">
        <span class="prev-page  "><a routerLink="/overview">Home</a></span>
        <img class="separator pr-2 pl-2" src="../../../assets/images/seperator.png">
        <span class="prev-page  "><a routerLink="/companies/companies-list">Companies</a></span>
        <img class="separator pr-2 pl-2" src="../../../assets/images/seperator.png">
        <span class="curr-page  breadcrumbs-section-font">Email Company</span>
      </div>

      <div class="d-flex justify-content-between meetings-layout">
        <div class="meetings ">Email Company
        </div>

      </div>
      <div class="mt-4 col-12 d-flex  row borders m-0 p-0 ">
        <div class="email-layout from pt-4">
          From:
        </div>
        <div class="pt-3">
          <div class="from-rectangle">
            <span class="from-id pl-3 pt-2">{{fromId}}</span>
          </div>
        </div>

      </div>
      <div class="mt-3 col-12 d-flex to-borders  m-0 p-0">
        <div class="to-email-layout from pt-2">
          To:
        </div>
        <div>
          <div class="d-flex row mr-5">
            <div class="d-flex">
              <div class="col-3-to-ids pb-2">
                <div class="d-flex">
                  <div class="rectangle-select">
                    <span class="to-id pl-3 pt-2">{{emailList}}</span>
                  </div>
                  <!-- <span>
                      <img class="image-pos-cross justify-content-end" src="/assets/images/cross-mark.png"
                        (click)="removeItems(email)"></span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="">
        <div class="col-12 row to-borders d-flex justify-content-between ml-0 mr-0 mt-1 mb-1 p-0 ">
          <div class="email-layout from mt-3">
            Subject:
          </div>
          <input type="text" class="pl-3 input-border-subject" [(ngModel)]="subject">

        </div>

      </div>
      <div class="email-layout ">
        <p>{{a}}</p>
        <div rows="4" id="emailIdBody" class="pl-3 input-border pt-3 layout-height c2 scroll-position"
          [innerHTML]="body"></div>
        <!-- <input type="text" class="pl-3 input-border pt-3 layout-height c2 scroll-position"   > -->
      </div>

      <div>

        <div class="d-flex justify-content-between meetings-layout button-footer">
          <div class="sub-label pt-3">
            <div class="d-flex" id="hi">
              <input type="radio"  class="gaps mr-2 mt-1" value="a" name="type" (change)="onItemChange($event.target.value)">
              <label for="Private suite" class="radio-label ">Private suite</label>
              <input type="radio"  class="gaps mr-2 ml-3 mt-1" value="b" name="type" (change)="onItemChange($event.target.value)">
              <label for="Flexi desk" class="radio-label ">Flexi desk</label>

            </div>

            <button class="cancel-button pr-1 mb-5">
              <span class="cancel" (click)="cancel()">Back to Companies Listing</span>
            </button>
          </div>
          <div class="pt-4">
            <button class="cancel-button pr-5">
              <span class="cancel" (click)="cancel()">Cancel</span>
            </button>
            <button class="add-button">
              <span class="add" (click)="sendemail()">Send Email</span>
            </button>
          </div>

        </div>
      </div>

    </div>
  </div>
